import { enqueueSnackbar } from 'notistack';

import { StatusError } from '../components/Providers/ErrorProvider';
import { enrichedFetch, handleError } from '../services/api';

export const errorMap: Record<
  number | string,
  {
    default_message?: string;
    function?: (retryTimes?: number, url?: string, options?: RequestInit) => Promise<unknown>;
  }
> = {
  400: { default_message: 'Bad Request' },
  401: {
    function: async (retryTimes?: number, url?: string, options?: RequestInit) => {
      const error = 'Unauthorized';
      const handler = await handleError(error, 401);
      if (handler && (retryTimes ?? 0) < 1) {
        console.log('User session was stale, retrying');
        return enrichedFetch(url as string, options, 1);
      } else {
        console.log('User refresh failed, logging out');
        throw new StatusError(error, 401);
      }
    },
  },
  403: { default_message: 'Not Authorized' },
  404: { default_message: 'Not Found' },
  452: {
    function: () => {
      enqueueSnackbar(
        "Input Exceeded Model's Context Limit - Please try shortening the message, files or creating a new conversation",
        {
          variant: 'error',
          autoHideDuration: 5000,
        }
      );
      throw new StatusError("Input Exceeded Model's Context Limit", 452);
    },
  },
  453: {
    function: () => {
      enqueueSnackbar('Content Filter Triggered', {
        variant: 'error',
        autoHideDuration: 3000,
      });
      throw new StatusError('Content Filter Triggered', 453);
    },
  },
  454: { default_message: 'Parsing Error' },
  500: { default_message: 'Internal Server Error' },
  501: { default_message: 'Unimplemented Error' },
  512: { default_message: 'Database Error' },
  513: { default_message: 'Teams Error' },
  514: { default_message: 'Craft Error' },
  515: { default_message: 'OpenAI Error' },
  516: { default_message: 'Databricks Error' },
  518: { default_message: 'Anthropic Error' },
  519: { default_message: 'GraphRag Error' },
};
